import utm from '@segment/utm-params';

let utmObj = utm(window.location.href);
let isTest = window.location.href.includes('test');

let platform = isTest ? 'test' : utmObj.source ? utmObj.source : 'organic';
let page = document.getElementById('main').dataset.pageName;
if (!page || page.length < 1) {
  page = window.location.href;
}

document.addEventListener('DOMContentLoaded', (e) => {

  let calendarButtons = document.querySelectorAll('.event-tracked');

  calendarButtons.forEach(button => {
    button.addEventListener('click', (e) => {

      let category = button.classList.contains('calendar') ? 'calendar' : 'live';

      if (category === 'live') {
        page = button.dataset.liveName;
      }
      trackEvent(platform, category, page);
    })
  });

  // update links on the page if using UTM
  if (utmObj.source) {

    let anchors = [...document.querySelectorAll('a')];

    anchors.map((anchor) => {
      let link = anchor.href;

      if (!link.includes('#') && !link.includes('.ics') && link.length > 0) { // links that aren't calendar download or anchor links;
        anchor.href += '?utm_source=' + utmObj.source;
      }
    })
  }
});


let formContainers = document.querySelectorAll( '.wpcf7' );
formContainers.forEach(formContainer => {
  formContainer.addEventListener('wpcf7mailsent', (e) => {

    let category = formContainer.querySelector('form').classList.contains('sms') ? 'sms' : 'enquiry';
    trackEvent(platform, category, page);
  })
});

function trackEvent(platform, category, page) {
  console.log('Event logged: ' + platform + '---' + category + '---' + page);
  _hmt.push(['_trackEvent', platform, category, page]);
}
